import styled from 'styled-components';

import { skinsGroupage } from 'modules/journey/card/styled/groupageBackground';

const ShipperOrderCircle = styled.span`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 1.6rem;
  background-color: ${({ skin }) => (skinsGroupage[skin] ? skinsGroupage[skin] : 'var(--grey200)')};
  display: block;
`;

export default ShipperOrderCircle;
